import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h1-bold-light",
  "use": "icon-h1-bold-light-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h1-bold-light\">\n<path d=\"M0.231995 3.07422V21.6382H3.27399V13.4222H12.686V21.6382H15.728V3.07422H12.686V10.8222H3.27399V3.07422H0.231995Z\" fill=\"#007AF5\" />\n<path d=\"M22.184 9.07422C21.752 9.52422 21.212 9.93822 20.564 10.3342C19.916 10.6942 19.304 10.9462 18.728 11.0902V13.1782C19.916 12.8362 20.888 12.3142 21.662 11.6122V21.9262H23.768V9.07422H22.184Z\" fill=\"#007AF5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol